import axiosWrapper from './axiosWrapper'

const URL_PRESUPUESTOS = `api/presupuestos`

function buscar(axiosParams, busqueda) {
  const url = `${axiosParams.baseURL}/${URL_PRESUPUESTOS}/buscar`
  return axiosWrapper.post({ ...axiosParams, url }, busqueda)
}

function estadisticas(axiosParams, busqueda) {
  const url = `${axiosParams.baseURL}/${URL_PRESUPUESTOS}/estadisticas`
  return axiosWrapper.post({ ...axiosParams, url }, busqueda)
}

const servicePresupuesto = {
  buscar,
  estadisticas
}

export default servicePresupuesto
